export const getMins = (d: any) => Number(d.split(':')[1]);
